<template>
    <div v-show="alert" :class="`b-alert ${hasContent ? 'hasContent' : ''}`">
        <div v-if="loading" class="pt-3 d-flex align-center justify-center">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
        </div>
        <v-alert
            v-else
            v-model="alert"
            :text="text"
            :outlined="outlined"
            :loading="loading"
            :color="type === 'warning' ? 'amber' : type"
            :elevation="elevation"
            :dismissible="!hasContent && dismissible"
        >
            <div class="header">
                <div v-if="title" class="title">{{ title }}</div>
                <div v-if="message" class="message" v-html="message"></div>
                <div v-if="hasContent" class="content-toggler">
                    <v-btn small icon @click="content = !content">
                        <v-icon v-show="content">mdi-chevron-up</v-icon>
                        <v-icon v-show="!content">mdi-chevron-down</v-icon>
                    </v-btn>
                </div>
                <v-btn
                    v-if="hasHeaderButton"
                    class="ml-4 alert-btn"
                    outlined
                    rounded
                    text
                    color="#fff"
                    @click="$emit('emitAction')"
                >
                    {{ buttonTitle ? buttonTitle : '' }}
                </v-btn>
            </div>
            <div v-if="content" class="body">
                <v-fade-transition>
                    <div v-show="content" v-if="list.length" class="list">
                        <ul>
                            <li v-for="(item, index) in list" :key="index">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <slot></slot>
                </v-fade-transition>
            </div>
        </v-alert>
    </div>
</template>

<script>
export default {
    name: 'BAlert',
    props: {
        type: {
            type: String,
            required: false,
            default: 'info',
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
        list: {
            type: Array,
            required: false,
            default: () => [],
        },
        message: {
            type: String,
            required: false,
            default: null,
        },
        elevation: {
            type: Number,
            return: false,
            default: 0,
        },
        outlined: {
            type: Boolean,
            required: false,
            default: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        text: {
            type: Boolean,
            required: false,
            default: true,
        },
        hasContent: {
            type: Boolean,
            required: false,
            default: false,
        },
        expanded: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasHeaderButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        buttonTitle: {
            type: String,
            required: false,
            default: '',
        },
        dismissible: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            alert: true,
            content: false,
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.$el.classList.add(`type-${this.type}`);
        if (this.hasContent && this.expanded) {
            this.content = !this.content;
        }
    },
    methods: {},
};
</script>

<style scoped></style>
